export const detectPlatform = () => {
    const userAgent = navigator.userAgent;
    const platform = navigator.platform;
    const mobileRegex = /Android|iPhone|iPad|iPod|BlackBerry|Mobile/i;

    const isMobileDevice = mobileRegex.test(userAgent);
    if (isMobileDevice) {
        return 'phone'
    }

    // 检测 Windows
    if (userAgent.includes('Win')) {
        return 'win';
    }

    // 检测 macOS
    if (userAgent.includes('Mac')) {
        // 检测 Apple Silicon (M芯片)
        if (navigator.userAgent.includes('Apple') &&
            !navigator.userAgent.includes('Intel') &&
            !navigator.userAgent.includes('x86')) {
            return 'mac_m';
        }

        // 检测 Intel Mac
        if (userAgent.includes('Intel') ||
            userAgent.includes('x86') ||
            platform === 'MacIntel') {
            return 'mac_intel';
        }

        // 其他情况默认为 Apple Silicon (较新的 Mac 通常为 M芯片)
        return 'mac_m';
    }

    return 'other';
}

export const timeFormat = (time, format) => {
    var o = {
        "M+": time.getMonth() + 1,                      //month
        "d+": time.getDate(),                           //day
        "h+": time.getHours(),                          //hour
        "m+": time.getMinutes(),                        //minute
        "s+": time.getSeconds(),                        //second
        "q+": Math.floor((time.getMonth() + 3) / 3),    //quarter
        "S": time.getMilliseconds()                     //millisecond
    }

    if (/(y+)/i.test(format)) {
        format = format.replace(RegExp.$1, (time.getFullYear() + "").substr(4 - RegExp.$1.length));
    }

    for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
            format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
    }
    return format;
}

export const getUrlParams = (params) => {
    const urlObj = new URL(window.location.href)
    const query = urlObj.searchParams.get(params)
    if (query) {
        return query
    }
    return ''
}
